import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import { ChatContainer, FloatingButton } from "./styles";
import { Props } from "./types";
import { useTheme } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";
import Grow from "@mui/material/Grow";

export const ChatPopup: React.FC<Props> = ({
  chatOpen,
  handleChatClick,
  children,
}) => {
  const theme = useTheme();
  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };
  return (
    <>
      <Grow in={chatOpen}>
        <ChatContainer
          sx={{
            zIndex: chatOpen ? 1000 : -1,
          }}
        >
          {children}
        </ChatContainer>
      </Grow>
      <Zoom
        in={chatOpen}
        timeout={transitionDuration}
        style={{
          transitionDelay: `0ms`,
        }}
        unmountOnExit
      >
        <FloatingButton onClick={handleChatClick}>
          {<CloseIcon sx={{ color: "black" }} />}
        </FloatingButton>
      </Zoom>
      <Zoom
        in={!chatOpen}
        timeout={transitionDuration}
        style={{
          transitionDelay: `0ms`,
        }}
        unmountOnExit
      >
        <FloatingButton onClick={handleChatClick}>
          {<ChatIcon id="step-10" sx={{ color: "black" }} />}
        </FloatingButton>
      </Zoom>
    </>
  );
};
